
import React from "react";
import PromoCard from "../ServiceSectionComponent.tsx/PromoCardService";
import { promoCardsData } from "../../../utils/Customer/CustomerData";

interface PromoBannerProps {
    onPromoClick?: (promoType: "relocation" | "vet_clinic") => void;
}

const PromoBanner: React.FC<PromoBannerProps> = ({ onPromoClick }) => {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {promoCardsData.map((card) => {
                const isRelocation = card.id === "relocation";

                return (
                    <PromoCard
                        key={card.id}
                        badgeText={card.badgeText}
                        badgeClassName={isRelocation ? "bg-green-100 text-green-600" : "bg-mainBrandColor text-white"}
                        title={<>{card.titleLine1} <br /> {card.titleLine2}</>}
                        description={card.description}
                        descriptionClassName={isRelocation ? "text-gray-500" : "text-logoHeading/70 max-w-sm"}
                        buttonText={card.buttonText}
                        buttonClassName={isRelocation ? "bg-logoHeading text-white" : "bg-mainBrandColor text-white"}
                        cardClassName={isRelocation ? "bg-white border-mediumgray" : "bg-[#E8F5E9] border-green-200"}
                        imageSrc={card.imageSrc}
                        imageAlt={card.imageAlt}
                        onButtonClick={() => onPromoClick?.(card.id)}
                    />
                );
            })}
        </div>
    );
};

export default PromoBanner;